import * as React from 'react';
import { FormContainer } from './components/Form';
import { getSettings } from '@app/src/configuration/config.service';

export const CreatePassword = ({ history }) => {
  sessionStorage.clear();

  return(
    <FormContainer
      history={history}
      url={getSettings().API_PASSWORD}
    />
  );
};

